
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7c69"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7c69"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $39249f7c3cf4f446$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["l1gf1","index.4f862baf.js","4NcCH","github.b513e581.png"]'));

const $0b89d474933103bc$export$ca000e230c0caa3e = {
    language: "EN"
};


var $63352299239db862$var$SSR_NODE = 1;
var $63352299239db862$var$TEXT_NODE = 3;
var $63352299239db862$var$EMPTY_OBJ = {};
var $63352299239db862$var$EMPTY_ARR = [];
var $63352299239db862$var$SVG_NS = "http://www.w3.org/2000/svg";
var $63352299239db862$var$id = (a)=>a;
var $63352299239db862$var$map = $63352299239db862$var$EMPTY_ARR.map;
var $63352299239db862$var$isArray = Array.isArray;
var $63352299239db862$var$enqueue = typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : setTimeout;
var $63352299239db862$var$createClass = (obj)=>{
    var out = "";
    if (typeof obj === "string") return obj;
    if ($63352299239db862$var$isArray(obj)) {
        for(var k = 0, tmp; k < obj.length; k++)if (tmp = $63352299239db862$var$createClass(obj[k])) out += (out && " ") + tmp;
    } else {
        for(var k in obj)if (obj[k]) out += (out && " ") + k;
    }
    return out;
};
var $63352299239db862$var$shouldRestart = (a, b)=>{
    for(var k in {
        ...a,
        ...b
    }){
        if (typeof ($63352299239db862$var$isArray(a[k]) ? a[k][0] : a[k]) === "function") b[k] = a[k];
        else if (a[k] !== b[k]) return true;
    }
};
var $63352299239db862$var$patchSubs = (oldSubs, newSubs = $63352299239db862$var$EMPTY_ARR, dispatch)=>{
    for(var subs = [], i = 0, oldSub, newSub; i < oldSubs.length || i < newSubs.length; i++){
        oldSub = oldSubs[i];
        newSub = newSubs[i];
        subs.push(newSub && newSub !== true ? !oldSub || newSub[0] !== oldSub[0] || $63352299239db862$var$shouldRestart(newSub[1], oldSub[1]) ? [
            newSub[0],
            newSub[1],
            (oldSub && oldSub[2](), newSub[0](dispatch, newSub[1]))
        ] : oldSub : oldSub && oldSub[2]());
    }
    return subs;
};
var $63352299239db862$var$getKey = (vdom)=>vdom == null ? vdom : vdom.key;
var $63352299239db862$var$patchProperty = (node, key, oldValue, newValue, listener, isSvg)=>{
    if (key === "style") for(var k in {
        ...oldValue,
        ...newValue
    }){
        oldValue = newValue == null || newValue[k] == null ? "" : newValue[k];
        if (k[0] === "-") node[key].setProperty(k, oldValue);
        else node[key][k] = oldValue;
    }
    else if (key[0] === "o" && key[1] === "n") {
        if (!((node.events || (node.events = {}))[key = key.slice(2)] = newValue)) node.removeEventListener(key, listener);
        else if (!oldValue) node.addEventListener(key, listener);
    } else if (!isSvg && key !== "list" && key !== "form" && key in node) node[key] = newValue == null ? "" : newValue;
    else if (newValue == null || newValue === false) node.removeAttribute(key);
    else node.setAttribute(key, newValue);
};
var $63352299239db862$var$createNode = (vdom, listener, isSvg)=>{
    var props = vdom.props;
    var node = vdom.type === $63352299239db862$var$TEXT_NODE ? document.createTextNode(vdom.tag) : (isSvg = isSvg || vdom.tag === "svg") ? document.createElementNS($63352299239db862$var$SVG_NS, vdom.tag, props.is && props) : document.createElement(vdom.tag, props.is && props);
    for(var k in props)$63352299239db862$var$patchProperty(node, k, null, props[k], listener, isSvg);
    for(var i = 0; i < vdom.children.length; i++)node.appendChild($63352299239db862$var$createNode(vdom.children[i] = $63352299239db862$var$maybeVNode(vdom.children[i]), listener, isSvg));
    return vdom.node = node;
};
var $63352299239db862$var$patch = (parent, node, oldVNode, newVNode, listener, isSvg)=>{
    if (oldVNode === newVNode) ;
    else if (oldVNode != null && oldVNode.type === $63352299239db862$var$TEXT_NODE && newVNode.type === $63352299239db862$var$TEXT_NODE) {
        if (oldVNode.tag !== newVNode.tag) node.nodeValue = newVNode.tag;
    } else if (oldVNode == null || oldVNode.tag !== newVNode.tag) {
        node = parent.insertBefore($63352299239db862$var$createNode(newVNode = $63352299239db862$var$maybeVNode(newVNode), listener, isSvg), node);
        if (oldVNode != null) parent.removeChild(oldVNode.node);
    } else {
        var tmpVKid;
        var oldVKid;
        var oldKey;
        var newKey;
        var oldProps = oldVNode.props;
        var newProps = newVNode.props;
        var oldVKids = oldVNode.children;
        var newVKids = newVNode.children;
        var oldHead = 0;
        var newHead = 0;
        var oldTail = oldVKids.length - 1;
        var newTail = newVKids.length - 1;
        isSvg = isSvg || newVNode.tag === "svg";
        for(var i in {
            ...oldProps,
            ...newProps
        })if ((i === "value" || i === "selected" || i === "checked" ? node[i] : oldProps[i]) !== newProps[i]) $63352299239db862$var$patchProperty(node, i, oldProps[i], newProps[i], listener, isSvg);
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $63352299239db862$var$getKey(oldVKids[oldHead])) == null || oldKey !== $63352299239db862$var$getKey(newVKids[newHead])) break;
            $63352299239db862$var$patch(node, oldVKids[oldHead].node, oldVKids[oldHead], newVKids[newHead] = $63352299239db862$var$maybeVNode(newVKids[newHead++], oldVKids[oldHead++]), listener, isSvg);
        }
        while(newHead <= newTail && oldHead <= oldTail){
            if ((oldKey = $63352299239db862$var$getKey(oldVKids[oldTail])) == null || oldKey !== $63352299239db862$var$getKey(newVKids[newTail])) break;
            $63352299239db862$var$patch(node, oldVKids[oldTail].node, oldVKids[oldTail], newVKids[newTail] = $63352299239db862$var$maybeVNode(newVKids[newTail--], oldVKids[oldTail--]), listener, isSvg);
        }
        if (oldHead > oldTail) while(newHead <= newTail)node.insertBefore($63352299239db862$var$createNode(newVKids[newHead] = $63352299239db862$var$maybeVNode(newVKids[newHead++]), listener, isSvg), (oldVKid = oldVKids[oldHead]) && oldVKid.node);
        else if (newHead > newTail) while(oldHead <= oldTail)node.removeChild(oldVKids[oldHead++].node);
        else {
            for(var keyed = {}, newKeyed = {}, i = oldHead; i <= oldTail; i++)if ((oldKey = oldVKids[i].key) != null) keyed[oldKey] = oldVKids[i];
            while(newHead <= newTail){
                oldKey = $63352299239db862$var$getKey(oldVKid = oldVKids[oldHead]);
                newKey = $63352299239db862$var$getKey(newVKids[newHead] = $63352299239db862$var$maybeVNode(newVKids[newHead], oldVKid));
                if (newKeyed[oldKey] || newKey != null && newKey === $63352299239db862$var$getKey(oldVKids[oldHead + 1])) {
                    if (oldKey == null) node.removeChild(oldVKid.node);
                    oldHead++;
                    continue;
                }
                if (newKey == null || oldVNode.type === $63352299239db862$var$SSR_NODE) {
                    if (oldKey == null) {
                        $63352299239db862$var$patch(node, oldVKid && oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newHead++;
                    }
                    oldHead++;
                } else {
                    if (oldKey === newKey) {
                        $63352299239db862$var$patch(node, oldVKid.node, oldVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                        oldHead++;
                    } else if ((tmpVKid = keyed[newKey]) != null) {
                        $63352299239db862$var$patch(node, node.insertBefore(tmpVKid.node, oldVKid && oldVKid.node), tmpVKid, newVKids[newHead], listener, isSvg);
                        newKeyed[newKey] = true;
                    } else $63352299239db862$var$patch(node, oldVKid && oldVKid.node, null, newVKids[newHead], listener, isSvg);
                    newHead++;
                }
            }
            while(oldHead <= oldTail)if ($63352299239db862$var$getKey(oldVKid = oldVKids[oldHead++]) == null) node.removeChild(oldVKid.node);
            for(var i in keyed)if (newKeyed[i] == null) node.removeChild(keyed[i].node);
        }
    }
    return newVNode.node = node;
};
var $63352299239db862$var$propsChanged = (a, b)=>{
    for(var k in a)if (a[k] !== b[k]) return true;
    for(var k in b)if (a[k] !== b[k]) return true;
};
var $63352299239db862$var$maybeVNode = (newVNode, oldVNode)=>newVNode !== true && newVNode !== false && newVNode ? typeof newVNode.tag === "function" ? ((!oldVNode || oldVNode.memo == null || $63352299239db862$var$propsChanged(oldVNode.memo, newVNode.memo)) && ((oldVNode = newVNode.tag(newVNode.memo)).memo = newVNode.memo), oldVNode) : newVNode : $63352299239db862$export$6f093cfa640b7166("");
var $63352299239db862$var$recycleNode = (node)=>node.nodeType === $63352299239db862$var$TEXT_NODE ? $63352299239db862$export$6f093cfa640b7166(node.nodeValue, node) : $63352299239db862$var$createVNode(node.nodeName.toLowerCase(), $63352299239db862$var$EMPTY_OBJ, $63352299239db862$var$map.call(node.childNodes, $63352299239db862$var$recycleNode), $63352299239db862$var$SSR_NODE, node);
var $63352299239db862$var$createVNode = (tag, { key: key, ...props }, children, type, node)=>({
        tag: tag,
        props: props,
        key: key,
        children: children,
        type: type,
        node: node
    });
var $63352299239db862$export$7c73462e0d25e514 = (tag, memo)=>({
        tag: tag,
        memo: memo
    });
var $63352299239db862$export$6f093cfa640b7166 = (value, node)=>$63352299239db862$var$createVNode(value, $63352299239db862$var$EMPTY_OBJ, $63352299239db862$var$EMPTY_ARR, $63352299239db862$var$TEXT_NODE, node);
var $63352299239db862$export$dda1d9f60106f0e9 = (tag, { class: c, ...props }, children = $63352299239db862$var$EMPTY_ARR)=>$63352299239db862$var$createVNode(tag, {
        ...props,
        ...c ? {
            class: $63352299239db862$var$createClass(c)
        } : $63352299239db862$var$EMPTY_OBJ
    }, $63352299239db862$var$isArray(children) ? children : [
        children
    ]);
var $63352299239db862$export$729c8b7179294ba = ({ node: node, view: view, subscriptions: subscriptions, dispatch: dispatch = $63352299239db862$var$id, init: init = $63352299239db862$var$EMPTY_OBJ })=>{
    var vdom = node && $63352299239db862$var$recycleNode(node);
    var subs = [];
    var state;
    var busy;
    var update = (newState)=>{
        if (state !== newState) {
            if ((state = newState) == null) dispatch = subscriptions = render = $63352299239db862$var$id;
            if (subscriptions) subs = $63352299239db862$var$patchSubs(subs, subscriptions(state), dispatch);
            if (view && !busy) $63352299239db862$var$enqueue(render, busy = true);
        }
    };
    var render = ()=>node = $63352299239db862$var$patch(node.parentNode, node, vdom, vdom = view(state), listener, busy = false);
    var listener = function(event) {
        dispatch(this.events[event.type], event);
    };
    return (dispatch = dispatch((action, props)=>typeof action === "function" ? dispatch(action(state, props)) : $63352299239db862$var$isArray(action) ? typeof action[0] === "function" ? dispatch(action[0], action[1]) : action.slice(1).map((fx)=>fx && fx !== true && (fx[0] || fx)(dispatch, fx[1]), update(action[0])) : update(action)))(init), dispatch;
};



var $b7e7587bc22d1cbd$export$2e2bcd8739ae039 = (children)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "header"
    }, children);




var $b1193a74fc5f57bb$export$2e2bcd8739ae039 = (state, language)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("span", {
        class: "language-button" + (state.language === language ? " selected" : ""),
        onclick: (state)=>{
            window.location.search = `lang=${language.toLowerCase()}`;
            return {
                ...state,
                language: language
            };
        }
    }, (0, $63352299239db862$export$6f093cfa640b7166)(language));


var $8b128b2dfbcdd618$export$2e2bcd8739ae039 = (state)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "language-selector"
    }, [
        (0, $b1193a74fc5f57bb$export$2e2bcd8739ae039)(state, "EN"),
        (0, $63352299239db862$export$6f093cfa640b7166)("|"),
        (0, $b1193a74fc5f57bb$export$2e2bcd8739ae039)(state, "FR")
    ]);



var $350e665957bab00d$export$2e2bcd8739ae039 = ()=>(0, $63352299239db862$export$dda1d9f60106f0e9)("span", {
        class: "line-jump"
    });



var $885a7b0a14f4bca1$exports = {};
$885a7b0a14f4bca1$exports = new URL("github.b513e581.png", import.meta.url).toString();


const $8d566c6ff9ccc4fb$export$af6694465029dab3 = (link)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("a", {
        href: link
    }, (0, $63352299239db862$export$dda1d9f60106f0e9)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($885a7b0a14f4bca1$exports)))
    }));
const $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8 = (link)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("a", {
        href: link
    }, (0, $63352299239db862$export$6f093cfa640b7166)("\uD83C\uDF10"));



const $363f796b9cd77ebb$var$sectionTitle = (title)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("h2", {
        class: "section-title"
    }, (0, $63352299239db862$export$6f093cfa640b7166)(title));
var $363f796b9cd77ebb$export$2e2bcd8739ae039 = (title, children)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "section"
    }, Array.isArray(children) ? [
        $363f796b9cd77ebb$var$sectionTitle(title),
        ...children
    ] : [
        $363f796b9cd77ebb$var$sectionTitle(title),
        children
    ]);



const $2fcab4d55240dbcd$var$Hexagon = (classes)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "hexagon" + classes
    }, [
        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {
            class: "outerHexagon" + classes
        }),
        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {
            class: "innerHexagon" + classes
        })
    ]);
const $2fcab4d55240dbcd$var$Jauge = (level)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "jauge"
    }, Array.from({
        length: 5
    }, (_, i)=>$2fcab4d55240dbcd$var$Hexagon(i < level ? " filled" : "")));
var $2fcab4d55240dbcd$export$2e2bcd8739ae039 = (name, level)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {}, [
        (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)(name)),
        $2fcab4d55240dbcd$var$Jauge(level)
    ]);



var $a09450665c14735a$export$2e2bcd8739ae039 = (children)=>(0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
        class: "white-page"
    }, children);


var $7f2afc126b9efe3e$export$2e2bcd8739ae039 = (state)=>{
    const l = state.language;
    return (0, $63352299239db862$export$dda1d9f60106f0e9)("div", {}, [
        (0, $8b128b2dfbcdd618$export$2e2bcd8739ae039)(state),
        (0, $a09450665c14735a$export$2e2bcd8739ae039)([
            (0, $b7e7587bc22d1cbd$export$2e2bcd8739ae039)([
                (0, $63352299239db862$export$dda1d9f60106f0e9)("h2", {
                    id: "myName"
                }, (0, $63352299239db862$export$6f093cfa640b7166)("Jules Fouchy")),
                (0, $63352299239db862$export$dda1d9f60106f0e9)("h2", {
                    id: "myTitle"
                }, [
                    (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                        EN: "Software Engineer, specialized in Computer Graphics",
                        FR: "Ing\xe9nieur Informatique, sp\xe9cialis\xe9 en Synth\xe8se d'Image"
                    }[l]))
                ]),
                (0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
                    id: "contact-infos"
                }, [
                    (0, $63352299239db862$export$dda1d9f60106f0e9)("p", {}, (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)("jules.fouchy@ntymail.com"))),
                    (0, $63352299239db862$export$dda1d9f60106f0e9)("p", {}, (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                        EN: "+337 83 94 51 77",
                        FR: "07 83 94 51 77"
                    }[l])))
                ])
            ]),
            (0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
                id: "columns-wrapper"
            }, [
                (0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
                    id: "column1"
                }, [
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Overview",
                        FR: "En bref"
                    }[l], [
                        (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "I am in love with programming; I enjoy all the creative freedom it offers us. I am particularly interested in 2D and 3D image generation, fulfilling my artistic interests.",
                            FR: "Passionn\xe9 de programmation, j'adore les possibilit\xe9s de cr\xe9ation infinies que cela nous offre. Je m'int\xe9resse particuli\xe8rement \xe0 la g\xe9n\xe9ration d'images en 2D et 3D, conciliant ainsi mon c\xf4t\xe9 artistique."
                        }[l]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("br", {}),
                        (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "I also appreciate web technologies for their versatility and the possibility to share content with the world.",
                            FR: "J'appr\xe9cie \xe9galement les technologies web pour leur versatilit\xe9 et les possibilit\xe9s de partage de contenu qu'elles nous offrent."
                        }[l])
                    ]),
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Skills",
                        FR: "Comp\xe9tences"
                    }[l], (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {
                        id: "skills"
                    }, [
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("C++", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Maths", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)({
                            EN: "Software Architecture",
                            FR: "Architecture Logicielle"
                        }[l], 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Processing / p5.js", 5),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("OpenGL", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Unity", 3),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Vulkan", 3),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Python", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Shaders (glsl / hlsl)", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Typescript / Javascript", 4),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Web", 3),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("React", 3),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("Machine Learning", 2),
                        (0, $2fcab4d55240dbcd$export$2e2bcd8739ae039)("C#", 3)
                    ])),
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Education",
                        FR: "\xc9tudes"
                    }[l], [
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "IMAC Creative Engineer",
                                FR: "Ing\xe9nieur Cr\xe9atif IMAC"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ingenieur-imac.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "Universit\xe9 Gustave Eiffel",
                            FR: "Universit\xe9 Gustave Eiffel"
                        }[l])),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2018 - June 2021",
                            FR: "Septembre 2018 - Juin 2021"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Master's degree: Science of Images",
                                FR: "Master 2 : Science de l'Image"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://igm.univ-gustave-eiffel.fr/formations/master-2-sciences-de-limage")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "Institut Gaspard Monge - Universit\xe9 Gustave Eiffel",
                            FR: "Institut Gaspard Monge - Universit\xe9 Gustave Eiffel"
                        }[l])),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2020 - June 2021",
                            FR: "Septembre 2020 - Juin 2021"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Preparatory class in mathematics and physics (MPSI-MP)",
                                FR: "Classe pr\xe9paratoire en math\xe9matiques et physique (MPSI-MP)"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://fr.wikipedia.org/wiki/Lyc%C3%A9e_Saint-Louis")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "Lyc\xe9e Saint-Louis, Paris",
                            FR: "Lyc\xe9e Saint-Louis, Paris"
                        }[l])),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2015 - June 2018",
                            FR: "Septembre 2015 - Juin 2018"
                        }[l]))
                    ]),
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Languages",
                        FR: "Langues"
                    }[l], [
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "French",
                                FR: "Fran\xe7ais"
                            }[l])),
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: " (Native)",
                                FR: " (Natif)"
                            }[l]))
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "English",
                                FR: "Anglais"
                            }[l])),
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: " (Fluent)",
                                FR: " (Courant)"
                            }[l]))
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "German",
                                FR: "Allemand"
                            }[l])),
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: " (Intermediate)",
                                FR: " (Interm\xe9diaire)"
                            }[l]))
                        ])
                    ])
                ]),
                (0, $63352299239db862$export$dda1d9f60106f0e9)("div", {
                    id: "column2"
                }, [
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Work Experience",
                        FR: "Exp\xe9riences professionnelles"
                    }[l], [
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Teaching Programming, Math and Computer Graphics at ICAN",
                                FR: "Cours de Programmation, Math\xe9matiques et Synth\xe8se d'Image \xe0 l'ICAN"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ican-design.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "March 2024 - Today",
                            FR: "Mars 2024 - Aujourd'hui"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Teaching C++ and Software Architecture at IMAC",
                                FR: "Cours de C++ et Architecture Logiciel \xe0 l'IMAC"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://julesfouchy.github.io/Learn--Clean-Code-With-Cpp/"),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ingenieur-imac.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2021 - Today",
                            FR: "Septembre 2021 - Aujourd'hui"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Rendering Engine Programmer at Spiders",
                                FR: "Programmeur Moteur de Rendu chez Spiders"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.spiders-games.com/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "March 2022 - September 2023",
                            FR: "Mars 2022 - Septembre 2023"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Teaching Creative Coding at IMAC",
                                FR: "Cours de Creative Coding \xe0 l'IMAC"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://julesfouchy.github.io/Learn--Generative-Art/"),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ingenieur-imac.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2020 - June 2022",
                            FR: "Septembre 2020 - Juin 2022"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Teaching Mathematics at IMAC",
                                FR: "Cours de Math\xe9matiques \xe0 l'IMAC"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://julesfouchy.github.io/miscellaneous/soutien-maths"),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ingenieur-imac.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2019 - June 2021",
                            FR: "Septembre 2019 - Juin 2021"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Internship at Ubisoft on Unity, as an Engine Programmer Assistant on Just Dance",
                                FR: "Stage \xe0 Ubisoft sur Unity, en tant que Programmeur Moteur Assistant sur Just Dance"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.ubisoft.com/en-us/company/about-us")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "April 2021 - September 2021",
                            FR: "Avril 2021 - Septembre 2021"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Internship at Virtual Arts (Cambridge, UK) to work on their game engine",
                                FR: "Stage \xe0 Virtual Arts (Cambridge, Royaume-Uni) pour d\xe9velopper leur moteur de jeux"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://www.virtualarts.co.uk/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "June 2020 - September 2020",
                            FR: "Juin 2020 - Septembre 2020"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "Teaching programming for teenagers at Centre Paris Anim' Victor Gelez",
                                FR: "Initiation \xe0 la programmation pour les 10-12 ans au Centre Paris Anim' Victor Gelez"
                            }[l])),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://cpa-victorgelez.ifac.asso.fr/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2019 - June 2020",
                            FR: "Septembre 2019 - Juin 2020"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "Maths private courses",
                            FR: "Cours particuliers de math\xe9matiques"
                        }[l])),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "September 2017 - Today",
                            FR: "Septembre 2017 - Aujourd'hui"
                        }[l]))
                    ]),
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Software Projects",
                        FR: "Projets Logiciel"
                    }[l], [
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Coollab")),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://coollab-art.com/"),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/CoolLibs/Lab")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A generative-art software with a node-based interface. Featuring 2D and 3D patterns and effects, particles, and more!",
                            FR: "Un logiciel d'art g\xe9n\xe9ratif avec une interface nodale. Effets et motifs 2D et 3D, particules, et plein d'autres !"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("p6")),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://julesfouchy.github.io/p6-docs/"),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/p6")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A simple C++ library for 2D drawing, inspired by p5.js",
                            FR: "Une librairie simple d'utilisation pour faire du dessin 2D en C++, inspir\xe9e de p5.js"
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Cool")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/CoolLibs")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A C++ framework designed for computer graphics software.",
                            FR: "Un framework C++ pour les logiciels bas\xe9s sur de la synth\xe8se d'image."
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Django")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/Django")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A VJing software based on a particle system, powered by compute shaders.",
                            FR: "Un logiciel de VJing bas\xe9 sur un syst\xe8me de particules, utilisant des compute shaders."
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Imacubes")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/IMACUBES"),
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "School project",
                                FR: "Projet scolaire"
                            }[l]))
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A voxel editor offering a few brushes and procedural terrain generation, supporting user-written shaders, shadows and ambient occlusion.",
                            FR: "Un \xe9diteur de voxels offrant quelques brushs et de la g\xe9n\xe9ration proc\xe9durale de terrain, avec des shaders customisables, ombres et occlusion ambiante."
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Mirror, Lasers & Robots")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/guillaume-haerinck/imac-tower-defense"),
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("i", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                                EN: "School project",
                                FR: "Projet scolaire"
                            }[l]))
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A tower defense game based on redirecting lasers through mirrors, written with an ECS architecture (Entity-Component-System).",
                            FR: "Un jeu de tower defense bas\xe9 sur la redirection de lasers avec des miroirs, cod\xe9 avec une architecture ECS (Entity-Component-System)."
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Tangram")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/Tangram2")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A 2D drawing software mainly focused on the possibility to write your own fragment shaders (in a Shadertoy-like fashion).",
                            FR: "Un logiciel de dessin 2D, essentiellement bas\xe9 sur la possibilit\xe9 d'\xe9crire ses propres fragment shaders (\xe0 la Shadertoy)."
                        }[l]))
                    ]),
                    (0, $363f796b9cd77ebb$export$2e2bcd8739ae039)({
                        EN: "Web Projects",
                        FR: "Projets Web"
                    }[l], [
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("DixImac")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/DixImac"),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://diximac.onrender.com")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "An online version of the Dixit board game.",
                            FR: "Une version en ligne du jeu de soci\xe9t\xe9 Dixit."
                        }[l])),
                        (0, $350e665957bab00d$export$2e2bcd8739ae039)(),
                        // Disabled because the site is down:
                        // h('span', {}, [
                        //     h('b', {}, text('DixImac Gallery')),
                        //     GithubLink('https://github.com/JulesFouchy/DixImacGallery'),
                        //     WebsiteLink('https://julesfouchy.github.io/DixImacGallery/'),
                        // ]),
                        // h('span', {}, text({
                        //     EN: 'A website to showcase the custom cards made for the DixImac game.',
                        //     FR: 'Un site web pour exposer les cartes créées spécialement pour le jeu DixImac.',
                        // }[l])),
                        // LineJump(),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, [
                            (0, $63352299239db862$export$dda1d9f60106f0e9)("b", {}, (0, $63352299239db862$export$6f093cfa640b7166)("Arcade Terminal of Photography")),
                            (0, $8d566c6ff9ccc4fb$export$af6694465029dab3)("https://github.com/JulesFouchy/ArcadeTerminalOfPhotography"),
                            (0, $8d566c6ff9ccc4fb$export$9acd664b4bb6d1a8)("https://julesfouchy.github.io/ArcadeTerminalOfPhotography/")
                        ]),
                        (0, $63352299239db862$export$dda1d9f60106f0e9)("span", {}, (0, $63352299239db862$export$6f093cfa640b7166)({
                            EN: "A simple photo editor, meant to explain the basics of images and their digital representation as pixels.",
                            FR: "Une petite application de retouche photo, destin\xe9e \xe0 expliquer quelques concepts de base sur les images et leur repr\xe9sentation en pixels."
                        }[l]))
                    ])
                ])
            ])
        ])
    ]);
};



const $b4e14b6b8da86996$var$tryFind = (identifier)=>{
    const search = window.location.search;
    const opt = identifier + "=";
    let begin = search.indexOf(opt);
    if (begin !== -1) begin += opt.length;
    const end = search.indexOf("&");
    return begin === -1 ? "" : end === -1 ? search.substring(begin) : search.substring(begin, end);
};
const $b4e14b6b8da86996$var$getState = ()=>{
    const language = ($b4e14b6b8da86996$var$tryFind("lang") || $b4e14b6b8da86996$var$tryFind("language")).toUpperCase();
    return language === "FR" || language === "EN" ? {
        ...(0, $0b89d474933103bc$export$ca000e230c0caa3e),
        language: language
    } : (0, $0b89d474933103bc$export$ca000e230c0caa3e);
};
(0, $63352299239db862$export$729c8b7179294ba)({
    init: $b4e14b6b8da86996$var$getState(),
    view: (0, $7f2afc126b9efe3e$export$2e2bcd8739ae039),
    node: document.body
});


//# sourceMappingURL=index.4f862baf.js.map
